import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Model } from 'app/model/backendmodel';
import { FileTypeCopySource } from 'app/model/pipeline/copysource/file-type.copysource';
import { BaseAsyncAdapter } from 'shell-models-lib';

export abstract class FileTypeSourceAdapter<T, U> extends BaseAsyncAdapter<T, U> {
    public static toSourceResource(model: FileTypeCopySource, resource: Model.CopySource): void {
        if (resource != null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (resource as any).recursive = ValueAdapter.toResource(model, FileTypeCopySource.RECURSIVE_SETTING);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (resource as any).maxConcurrentConnections = ValueAdapter.toResource(
                model,
                FileTypeCopySource.MAXCONCURRENT_CONNECTIONS
            );
        }
    }

    public static toSourceModel(resource: Model.CopySource, model: FileTypeCopySource): void {
        if (model != null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ValueAdapter.toModel(model, FileTypeCopySource.RECURSIVE_SETTING, (resource as any).recursive);
            ValueAdapter.toModel(
                model,
                FileTypeCopySource.MAXCONCURRENT_CONNECTIONS,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (resource as any).maxConcurrentConnections
            );
        }
    }
}
